module.exports = __webpack_public_path__ + "img/THSR.0bf4d1a3.svg";